/* @ngInject */
function documentsService (
  CONSTANTS,
  ConnectorWebService,
  Utils
) {
  return {
    getDocumentById,
    emitEventsToReact
  }

  function getDocumentById (docId) {
    var url = Utils.fnReplaceStringParams(CONSTANTS.URL_DOCS_ID, [docId])
    return ConnectorWebService.get(url)
  }

  function emitEventsToReact (eventType, eventData) {
    const data = {
      type: eventType,
      data: eventData,
      timestamp: Date.now()
    }

    const iframe = document.querySelector('.editor-iframe')
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(data, '*')
    }
  }
}

export { documentsService }
